export interface RefreshQueueItem {
  resolve: (token: string) => void;
  reject: (error: unknown) => void;
}

export type TokenRefreshOutcome = { ok: true; accessToken: string } | { ok: false; error: unknown };

export function drainRefreshQueue(
  queue: RefreshQueueItem[],
  error: unknown,
  token: string | null = null
): void {
  queue.forEach((prom) => {
    if (token != null) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });
  queue.length = 0;
}

export async function completeTokenRefresh(args: {
  refresh: () => Promise<{ access_token: string; refresh_token: string }>;
  saveAccessToken: (token: string) => Promise<void>;
  saveRefreshToken: (token: string) => Promise<void>;
  queue: RefreshQueueItem[];
}): Promise<TokenRefreshOutcome> {
  try {
    const tokens = await args.refresh();
    await args.saveAccessToken(tokens.access_token);
    await args.saveRefreshToken(tokens.refresh_token);
    drainRefreshQueue(args.queue, null, tokens.access_token);
    return { ok: true, accessToken: tokens.access_token };
  } catch (refreshError: unknown) {
    drainRefreshQueue(args.queue, refreshError);
    return { ok: false, error: refreshError };
  }
}
